module.exports = __webpack_public_path__ + "components/rewards/ski-line/static/logo-d42377699d1f28521978b25824e3182d.webp";